import React from 'react';
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router";
import {Breadcrumb, Col, Container, Row} from "react-bootstrap";
import {NewForm} from "./forms/NewForm";

const License = () => {
    const {t} = useTranslation();
    const navigate = useNavigate()

    const handleHome = () => {
        navigate("/license")
    }

    return(<Container fluid={true}>
        <Row className={"justify-content-end"}>
            <Col className={"d-flex justify-content-start"}>
                <Breadcrumb className={"mt-3"}>
                    <Breadcrumb.Item onClick={handleHome}>{t('breadcrumbs.home')}</Breadcrumb.Item>
                    <Breadcrumb.Item active>
                        {t('breadcrumbs.new')}
                    </Breadcrumb.Item>
                </Breadcrumb>
            </Col>
        </Row>
        <NewForm/>
    </Container>)
}

export default License;